import React from 'react'
import { formatDate, defaultDateFormat } from '@/utils/dateUtilities'
import moment from 'moment'

const getFormatString = () => { return defaultDateFormat }

const DueDateWrapper = (props) => {
  const { dueDate } = props
  let className = 'ok-date'
  const dateDifference = moment(new Date()).diff(dueDate, 'hours')
  if (dateDifference > 0) {
    className = 'danger-date'
  } else if (dateDifference < 0 && dateDifference > -48) {
    className = 'warning-date'
  }
  if (dueDate.isValid()) {
    return <span className={`due-date-label ${className}`}>{formatDate(dueDate, getFormatString())}</span>
  } else {
    return <span className={`due-date-label undefined-date`}>-</span>
  }
}

export {
  DueDateWrapper
}



// WEBPACK FOOTER //
// ./src/components/dueDateWrapper.js